import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CreatureInstance,
  RollPlus,
  RolledValue,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

import ButtonBox from "@components/input/buttons/ButtonBox";
import Roller from "@dndComponents/other/Roller";
import ToastBox from "@components/display/ToastBox";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  disabled: boolean;
  trim?: boolean;
  obj: CreatureInstance;
  onChange: () => void;
}

const char_util = DandDCharacterUtilities.getInstance();
const common_util = CommonUtilities.getInstance();

export default function CreatureInstanceSkills({
  obj,
  disabled,
  trim,
  onChange
}: Props) {
  const [roll, setRoll] = useState<RolledValue[]>([]);
  const [popoverSkill, setPopoverSkill] = useState("");
  const [popoverTime, setPopoverTime] = useState(-1);
  const [open, setOpen] = useState(false);

  const renderSkill = (skill_prof: { skill_id: string, prof_level: number, skill_name: string, modifier: number }, key: number) => {
    return (
      <Grid
        size={{
          xs: 4
        }}>
        <div className="curved_border" style={{
            padding: "4px"
          }}>
          <Grid container spacing={0} direction="row" style={{ margin: "4px" }}>
            <Grid
              size={{
                xs: trim ? 7 : 9
              }}>
              <div style={{ float: "left", lineHeight: "2.2" }} className="header">
                { skill_prof.skill_name }
              </div>
            </Grid>
            <Grid
              size={{
                xs: trim ? 5 : 3
              }}>
              <ButtonBox 
                name={`${common_util.addPlusMaybe(skill_prof.modifier)}`}
                disabled={ disabled }
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                  const rolls: RollPlus[] = [];
                  const roll_plus = new RollPlus();
                  roll_plus.flat = skill_prof.modifier;
                  rolls.push(roll_plus);
                  // console.log(rolls);
                  const new_roll = char_util.rollD20({ char_interface: obj, rolls, type: "Skill" });
                  setRoll(new_roll);
                  setPopoverSkill(skill_prof.skill_name);
                  setPopoverTime(common_util.get_time_number());
                }} 
              />
            </Grid>
          </Grid>
        </div>
      </Grid>
    );
  }

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={ open } 
          onClose={() => {
            setOpen(false);
            obj.subscription_holder.modalClosed();
          }}>
          <span>Skill Details</span>
        </ModalOrDrawer>
        <ToastBox
          openTime={ popoverTime }
        >
          { renderRoll() }
        </ToastBox>
      </>
    );
  }

  const renderRoll = () => {
    return (
      <Roller 
        name={popoverSkill}
        rolled_values={roll}
        type="Skill" 
      />
    );
  }

  return (
    <Grid key="Skills" container spacing={0} direction="row" 
      className="curved_border bg_black_transp">
      { obj.skill_proficiencies2.map((skill_prof, key) => {
        return renderSkill(skill_prof, key);
      })}
      { renderExtras() }
    </Grid>
  );
}
